// NOTE: The platform-neutral shape of one timeline row. A `kind` rather than an
// i18n key: the sentence is a per-platform rendering decision, while WHICH
// sentence applies is a shared rule.
export enum ESkillActivationTimelineKind {
  LOADED_EXPLICIT = "loadedExplicit",
  LOADED_AUTOMATIC = "loadedAutomatic",
  UNAVAILABLE = "unavailable",
}

export interface ISkillActivationTimelineItem {
  key: string;
  kind: ESkillActivationTimelineKind;
  // NOTE: The skill's name AT ACTIVATION TIME. Null only on the unavailable row,
  // where there is no authorized name to show.
  name: string | null;
}

// NOTE: The i18n keys the three row kinds render as, in the `skills` bundle both
// apps load. It lives beside the row shape rather than in each client so a new kind
// cannot be rendered as one sentence on web and another on mobile.
export type TSkillTimelineMessageKey =
  | "timeline.loadedAutomatic"
  | "timeline.loadedExplicit"
  | "timeline.unavailable";
